export const noopDeserializer = () => {
  return () => null;
};
